import { useCallback, useMemo, useState } from 'react';

export default function useModal() {
  const [modalContent, setModalContent] = useState(null);

  const onClose = useCallback(() => {
    setModalContent(null);
  }, []);

  const modal = useMemo(() => {
    if (modalContent === null) {
      return null;
    }
    const { content, title } = modalContent;
    return { onClose, content, title };
  }, [modalContent, onClose]);

  const showModal = useCallback((title, getContent, closeOnClickOutside = false) => {
    setModalContent({ closeOnClickOutside, content: getContent(onClose), title });
  }, [onClose]);

  return [modal, showModal];
}
